import { Link } from "react-router-dom";
import MangaCard from "./MangaCard";
import type { Manga } from "@/mocks/manga";
import { categories, categorySlugMap } from "@/mocks/categories";

interface Props {
  title: string;
  subtitle?: string;
  mangaList: Manga[];
  linkTo?: string;
  linkLabel?: string;
}

export default function MangaSection({ title, subtitle, mangaList, linkTo, linkLabel }: Props) {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900">{title}</h2>
          {subtitle && <p className="text-xs text-foreground-500 mt-1">{subtitle}</p>}
        </div>
        {linkTo && (
          <Link to={linkTo} className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap transition-colors">
            {linkLabel || "查看更多"} <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 md:gap-5">
        {mangaList.map((manga) => (
          <MangaCard
            key={manga.id}
            slug={manga.slug}
            title={manga.title}
            coverUrl={manga.coverUrl}
            status={manga.status}
            rating={manga.rating}
            category={categorySlugMap[manga.category] || manga.category}
            views={manga.views}
            chapters={manga.chapters.length}
          />
        ))}
      </div>
    </section>
  );
}